import { create } from "zustand";
import { persist, createJSONStorage, devtools } from "zustand/middleware";

const initialState = {
  userCountry: "US", // Default country for phone input
  // Add more UI preferences here in the future
  theme: "light",
  language: "en",
};

export const usePreferencesStore = create(
  devtools(
    persist(
      (set) => ({
        ...initialState,

        // Actions
        setUserCountry: (countryCode) =>
          set({ userCountry: countryCode }, false, "setUserCountry"),

        setTheme: (theme) => set({ theme }, false, "setTheme"),

        setLanguage: (language) => set({ language }, false, "setLanguage"),

        // Clear all preferences
        clearPreferences: () => set(initialState, false, "clearPreferences"),
      }),
      {
        name: "user-preferences",
        storage: createJSONStorage(() => localStorage),
      }
    ),
    {
      name: "PreferencesStore",
    }
  )
);

// Selectors for easier access
export const useUserCountrySelector = () =>
  usePreferencesStore((state) => state.userCountry);
export const useThemeSelector = () =>
  usePreferencesStore((state) => state.theme);
export const useLanguageSelector = () =>
  usePreferencesStore((state) => state.language);
